import { Control, FieldValues, Path, useController } from 'react-hook-form';
import AceEditor from 'react-ace';
import 'brace/theme/tomorrow_night_blue';
import 'brace/mode/twig';

import styled from 'styled-components';
import { Utils } from '@treezor/design-system';

const Editor = styled.div`
  display: flex;
  flex: 1;

  div#editorTemplate {
    border-top-left-radius: 0.4rem;

    .ace_scroller {
      margin: 0.5rem 0.2rem;
    }
    .ace_gutter {
      margin-top: 0.5rem;
    }
    .ace_scrollbar-v {
      right: 0.5rem;
    }
    .ace_scrollbar-h {
      bottom: 0.5rem;
    }
    .ace_scrollbar {
      ::-webkit-scrollbar {
        width: 0.2rem;
        height: 0.2rem;
      }
      ::-webkit-scrollbar-thumb {
        background: ${({ theme }) => Utils.hexColorAddOpacity(theme.palette.secondary, 0.5)};
        border-radius: 0.2rem;
      }
    }
    z-index: 1;
  }
`;

export interface ITemplateProps<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
}

const TemplateEditor = <T extends FieldValues>({ control, name }: ITemplateProps<T>) => {
  const { field } = useController({
    name,
    control,
  });

  const handleChange = (value: string) => {
    field.onChange(value);
  };

  return (
    <Editor id="editor-template">
      <AceEditor
        mode="twig"
        theme="tomorrow_night_blue"
        onChange={handleChange}
        name="editorTemplate"
        fontSize={12}
        style={{
          width: '100%',
          height: 'calc(100vh - 350px)',
          minHeight: 480,
        }}
        showPrintMargin={false}
        showGutter={true}
        highlightActiveLine={true}
        editorProps={{
          $blockScrolling: true,
        }}
        setOptions={{
          enableBasicAutocompletion: true,
          enableLiveAutocompletion: true,
          enableSnippets: true,
          showLineNumbers: true,
          tabSize: 2,
        }}
        value={field.value}
      />
    </Editor>
  );
};

export default TemplateEditor;
